import {
  UpdateTenantConfigPayload,
  UpdateTenantConfigResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateTenantConfig(
  tenantId: string,
  onSuccess?: (data: UpdateTenantConfigResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/config`;
  const request = new Request(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    UpdateTenantConfigResponse,
    UpdateTenantConfigPayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['tenant-details', tenantId],
      ['admin-tenant-details', tenantId],
    ],
    onSuccess,
    onError,
  });
}

export default useUpdateTenantConfig;
